import Svg from "@common/svg"
import { TabProps } from "@common/types"

interface circleTabProps extends TabProps {
  isLast: boolean
  label?: string
}

export default function CircleTab({
  isSelected,
  isCompleted,
  index,
  onSelect,
  isLast,
  icon = "check",
  children,
  label,
}: circleTabProps) {
  const borderClasses = isSelected ? "border-primary" : "border-none"
  const iconWrapperClass = isCompleted
    ? `bg-primary w-5 h-5 flex items-center justify-center`
    : `bg-gray-400 dark:bg-gray-600 w-3 h-3`
  const lineStyle = isCompleted ? "bg-primary" : "bg-gray-400 dark:bg-gray-600"

  return (
    <>
      <button
        onClick={() => onSelect && onSelect(index as number)}
        className={`w-5 h-5 rounded-full border-2 flex shrink-0 justify-center items-center ${borderClasses} relative`}
      >
        {children ??
          (label && (
            <div
              className={`absolute -top-6  text-sm   ${
                isCompleted
                  ? "text-gray-900 dark:text-gray-100 font-semibold"
                  : "text-gray-700 dark:text-gray-300"
              } `}
            >
              {label}
            </div>
          ))}
        <div className={`rounded-full m-auto ${iconWrapperClass}`}>
          {isCompleted && (
            <Svg
              tooltipContent={undefined}
              name={icon}
              strokeWidth={3}
              classes="w-3 h-4 text-white"
            />
          )}
        </div>
      </button>
      {!isLast && <div className={`w-full h-[2px] m-auto ${lineStyle}`}></div>}
    </>
  )
}
